// Paths where the domain user query (`['user']`, hits `/api/users` through the axios 401
// interceptor) must not run: public/landing and auth-callback routes.
export const AUTH_EXCLUDED_PATHS = [
  '/',
  '/signup',
  '/login',
  '/logout',
  '/forgot-password',
  '/garmin-auth',
  '/coros-auth',
];

// Paths where the BetterAuth session query (`['auth']`) must not run. Deliberately narrower
// than AUTH_EXCLUDED_PATHS: `getSession()` bypasses the axios interceptor and simply resolves
// to null when unauthenticated, so it is safe on /login, /signup and `/` — and it must run
// there so a returning user with a valid cookie is forwarded into the app instead of being
// shown the login form on every cold start.
export const SESSION_EXCLUDED_PATHS = [
  '/logout',
  '/garmin-auth',
  '/coros-auth',
];
